import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "./header.css";
import { Link, useNavigate, NavLink } from "react-router-dom";
import "./header.css";
import Notification from "./../notification";
import Profile from "../profile";
import QuickOrderPopup from "../quickOrderPopup";
import CartSummary from "../cartSummery";
import { useDispatch, useSelector } from "react-redux/es/exports";
import { log } from "console";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import * as PusherPushNotifications from "@pusher/push-notifications-web";
import { ToastContainer } from "react-toastify";
import Pusher from "pusher-js";
import {
  mobilemenu,
  moreitems,
  quickorder,
  myprofile,
  logout,
  phonecall,
  cart,
  loguser,
  dry3,
  dry1,
  dry2,
  curtain1,
  curtain2,
  curtain3,
  wedding1,
  wedding2,
  wedding3,
  leather1,
  leather2,
  leather3,
  alteration2,
  alteration1,
  alteration3,
  upholstery1,
  upholstery2,
  upholstery3,
  duvets1,
  duvets2,
  duvets3,
  fire1,
  fire2,
  fire3,
  key1,
  key2,
  key3,
  tocservice1,
  tocservice2,
  tocservice3,
  tocsrepair1,
  tocsrepair2,
  tocsrepair3,
  tocrug1,
  tocrug2,
  tocrug3,
  tocironing1,
  tocironing2,
  tocironing3,
  toccarpet1,
  toccarpet2,
  toccarpet3,
} from "../../assets/img";
import { fetchHomeJsonList, getHomeJsonList } from "../../redux/Actions";
import { checkShopListFlow } from "../../utility";

// import ReactGA from 'react-ga';

// const TRACKING_ID = "UA-265690492-2"; // OUR_TRACKING_ID
// ReactGA.initialize(TRACKING_ID);

const getUser = () => {
  const token: any = localStorage.getItem("userDetails");
  return token ? JSON.parse(token) : "";
};

function HeaderBlack() {
  const [changePopup, setChangePopup] = useState(false);
  const [changePopupProfile, setChangePopupProfile] = useState(false);
  const [quickBookPopup, setQuickBookPopup] = useState(false);
  const [cartSummary, setCartSummary] = useState(false);
  const [userName, setUserName] = useState<any>("");
  const [userToken, setUserToken] = useState();

  const [cartValue, setCartValue] = useState<any>([]);
  const [pusherKey, setpusherKey] = useState<any>("");
  const state: any = useSelector<any>((state) => state);
  const menuRef = React.useRef<HTMLDivElement>(null);
  const { cartCount }: any = useSelector<any>((state) => state);
  const [notifyCount, setNotifyCount] = useState<any>([]);
  const [cartCounts, setCartCount] = useState<number>(0);
  const [finalTotalPrice, setFinalTotalPrice] = useState<number>(0);
  const name = localStorage.getItem("username");

  const dispatch = useDispatch<any>();

  const homedata: any = useSelector<any>((state) => state?.homeJsonList);
  useEffect(() => {}, [homedata]);

  useEffect(() => {}, [window.location.href]);

  const selectedCategories: any = useSelector<any>(
    (state) => state.userSelectedCategories
  );

  const settingsData: any = useSelector<any>((state) => state?.settings);

  const base_url = process.env.REACT_APP_BACKEND_URL;
  const Url = window.location.host;
  const blogUrl = `https://blog.${Url}`;
  const shopurl = 'https://bestatlaundry.com/laundry'
  const activeUrl = window.location.pathname;
  const [settings, setSettings] = useState<any>({});

  useEffect(() => {
    dispatch(getHomeJsonList());
  }, []);
  useEffect(() => {
    setSettings(settingsData);
  }, [settingsData]);
  useEffect(() => {
    if (state.userDetails.data) {
      const user_info = state.userDetails.data?.user_info;
      const { name = "" } = user_info;
      // const token = getToken();
      setUserToken(name);
      setUserName(name);
    }

    const selectedMainCategory = selectedCategories?.filter((item: any) => {
      return item?.sub_categories?.some(
        (subItem: any) => parseInt(subItem?.quantity) > 0
      );
    });

    let finalTotalPrice = 0;
    let itemsCount = 0;

    if (selectedMainCategory.length) {
      selectedMainCategory?.map((item: any) => {
        const subcategoryList = item?.sub_categories?.filter(
          (subItem: any) => parseInt(subItem.quantity) > 0
        );
        itemsCount = itemsCount + subcategoryList?.length;
        subcategoryList?.map((subcategory: any) => {
          finalTotalPrice =
            finalTotalPrice +
            parseInt(subcategory?.quantity) *
              parseFloat(subcategory?.total_price);
        });
      });

      // cartInformationData?.map((item: any) => {
      //   const subcategoryList = item?.sub_categories?.filter(
      //     (subItem: any) => parseInt(subItem.quantity) > 0);
      // });
    }
    setFinalTotalPrice(finalTotalPrice);
    setCartCount(itemsCount);
  }, [state]);

  const navigate = useNavigate();
  const handleLogout = (e: any) => {
    e.preventDefault();
    localStorage.clear();
    navigate("/login");
    window.location.reload();
  };
  useEffect(() => {
    AOS.init();
    // AOS.refresh();
  }, []);

  const [sticky, setSticky] = useState("");

  // on render, set listener
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  const isSticky = () => {
    const scrollTop = window.scrollY;
    const stickyClass = scrollTop >= 100 ? "fixed" : "";
    setSticky(stickyClass);
  };

  const fixedheader = `header ${sticky}`;
  function addNotify() {
    setNotifyCount((prevState: any) => [...prevState, "1"]);
  }

  let oldNotify = "";

  useEffect(() => {
    if (localStorage.getItem("userDetails")) {
      const userInfo = JSON.parse(localStorage.getItem("userDetails")!);

      const { data } = userInfo;

      if (data != null) {
        // const notifyLocalCount = localStorage.getItem('notifyCount');

        const interest = data.user_info.notification_interest_list;

        if (interest[1] != undefined) {
          const intrst = interest[1];
          var pusher = new Pusher(pusherKey, {
            cluster: "eu",
          });

          var channel = pusher.subscribe(intrst);
          channel.bind("my-event", function (datas: any) {
            let event = datas.order;
            // alert(event.title);
            // toast.dismiss();

            // setNotifyCount(notifyCount);

            // var newArray = notifyCount.concat('1');

            //

            // const rand = Math.random();

            // setNotifyCount(notifyCount.concat(rand));
            // setNotifyCount((prevState: any) => ([...prevState, '1']))

            if (oldNotify != event.order_id) {
              addNotify();
              oldNotify = event.order_id;
            }

            // localStorage.setItem('notifyCount', `${parseInt(notifyLocalCount!) + 1}`);

            // setNotifyCount(notifyCount + 1);
            // toast(<div>{event.title}<br />{event.body}</div>, { autoClose: false });
          });
        }
      }

      if (data) {
        const user_info = data?.user_info;
        const { name = "" } = user_info;
        // const token = getToken();
        setUserToken(name);
        setUserName(name);
      }

      // setUserToken(token);
    }
    let handler = (event: { target: Node | null }) => {
      if (menuRef.current) {
        if (!menuRef.current.contains(event.target)) {
          setChangePopupProfile(false);
          setCartSummary(false);
        }
      }
    };
    document.addEventListener("mousedown", function name(params: any) {
      handler(params);
    });
    document.addEventListener("scroll", function name() {
      // AOS.init();
      AOS.refresh();
    });
  }, []);

  const location = useLocation();
  let newurl = location.pathname;
  let splitURL: any = newurl.toString().split("/");

  useEffect(() => {
    sidebarClose();
    cartboxClose();
  }, [location]);

  var sidebar = document.getElementById("sidebar");
  var overlay = document.getElementById("overlay");
  var cartoverlay = document.getElementById("cd-shadow-layer");
  var cdcart = document.getElementById("cd-cart");

  const cartboxClose = () => {
    cdcart?.classList.remove("speed-in");
    cartoverlay?.classList.remove("is-visible");
  };
  const cartboxOpen = () => {
    cdcart?.classList.add("speed-in");
    cartoverlay?.classList.add("is-visible");
  };

  const sidebarClose = () => {
    sidebar?.classList.remove("active");
    overlay?.classList.remove("active");
  };
  const sidebarOpen = () => {
    sidebar?.classList.add("active");
    overlay?.classList.add("active");
  };

  function openQuickOrderPopup() {
    setQuickBookPopup(!quickBookPopup);
    localStorage.setItem("disableLoader", "yes");
  }
  function closeQuickOrderPopup() {
    setQuickBookPopup(false);
    localStorage.removeItem("disableLoader");
  }

  return (
    <div>
      {/* <div className="home-offer">
          <p className="title">Limited Time Offer 32% Discount on First Booking</p><button className="btn">Know More</button>
          <a className="home-offer-close"><i className="uil uil-times-circle"></i></a>
      </div> */}      
      <header
        className={fixedheader}
      >
        <div className="header-top">
          <div className="container-fluid">
            <div className="row header-nav">
              <div className="col-md-auto col-sm-12">
                <div className="logo">
                  <span
                    id="sidebarCollapse"
                    className="d-block d-md-none"
                    onClick={sidebarOpen}
                  >
                    <img src={mobilemenu} className="img-fluid" alt="" />
                  </span>
                  <Link to="/">
                    <img
                      id="site_logo"
                      src={`${
                        Object.keys(settings).length > 0 &&
                        settings.WebsiteSettings.logo_path
                      }${
                        Object.keys(settings).length > 0 &&
                        settings.WebsiteSettings.style_logo_en
                      }`}
                      // src={`${Object.keys(settings).length > 0 && settings.WebsiteSettings.style_logo_en}`}
                      alt=""
                    />
                  </Link>
                  <span className="mob-user hidden-md dropdown d-block d-md-none">
                    <img
                      src={moreitems}
                      className="img-fluid"
                      alt=""
                      data-bs-toggle="dropdown"
                    />
                    <ul
                      role="menu"
                      className="dropdown-menu"
                      aria-labelledby="drop1"
                    >
                      {homedata?.theme_10?.home?.header?.btn_group?.btn2
                        ?.btn2_is_enable && (
                          <>
                          {settingsData?.quick_order_mode != 0 &&
                        <li>
                          <a
                            href="javascript:void(0);"
                            data-bs-toggle="modal"
                            data-bs-target="#quickordermodal"
                            style={{
                              background: `${homedata?.theme_10?.home?.btn_group?.btn2?.bg_color}`,
                              color: `${homedata?.theme_10?.homedata?.theme_10?.home?.btn_group?.btn2?.color}`,
                              borderColor: `${homedata?.theme_10?.home?.btn_group?.btn2?.border_color}`,
                            }}
                          >
                            <i className="uil uil-shopping-cart-alt me-2"></i>
                            {
                              homedata?.theme_10?.home?.header?.btn_group?.btn2
                                ?.text
                            }
                          </a>
                        </li>
                          }
                        </>
                      )}
                      {!userToken && (
                        <li className="login">
                          <Link
                            to="/login"
                            style={{
                              background: `${homedata?.theme_10?.home?.btn_group?.btn1?.bg_color}`,
                              color: `${homedata?.theme_10?.homedata?.theme_10?.home?.btn_group?.btn1?.color}`,
                              borderColor: `${homedata?.theme_10?.home?.btn_group?.btn1?.border_color}`,
                            }}
                          >
                            <i className="uil uil-user-circle me-2"></i>{" "}
                            {
                              homedata?.theme_10?.home?.header?.btn_group?.btn1
                                ?.text
                            }
                          </Link>
                        </li>
                      )}
                      {userToken && (
                        <li className="dropdown menu-hover-dropdown">
                          <a
                            className="menuitem"
                            href="#"
                            onClick={(e) => handleLogout(e)}
                            style={{
                              background: `${homedata?.theme_10?.home?.btn_group?.btn1?.bg_color}`,
                              color: `${homedata?.theme_10?.homedata?.theme_10?.home?.btn_group?.btn1?.color}`,
                              borderColor: `${homedata?.theme_10?.home?.btn_group?.btn1?.border_color}`,
                            }}
                          >
                            <i className="uil uil-sign-out-alt me-2"></i>
                            {
                              homedata?.theme_10?.home?.header?.btn_group?.btn1
                                ?.text
                            }
                          </a>
                        </li>
                      )}
                    </ul>
                  </span>
                </div>
                {settings?.WebsiteSettings?.site_title_en ==
                  "Insta Laundry" && (
                  <div className="contact">
                    <ul className="header-topnav-contact">
                      <li>
                        <a
                          href={`tel:${homedata?.home?.footer?.footer_section?.callnow_for_Services_section?.mbl_no?.label}`}
                          className=""
                        >
                          <i className="uil uil-phone me-2"></i>
                          {
                            homedata?.home?.footer?.footer_section
                              ?.callnow_for_Services_section?.mbl_no?.label
                          }
                        </a>
                      </li>
                      <li>
                        <a
                          href={`mailto:${homedata?.home?.footer?.footer_section?.callnow_for_Services_section?.email?.value}`}
                          className=""
                        >
                          <i className="uil uil-envelope me-2"></i>
                          {
                            homedata?.home?.footer?.footer_section
                              ?.callnow_for_Services_section?.email?.value
                          }
                        </a>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
              <div className="col-md col-sm-12">
                <div
                  className="d-none d-md-flex align-items-center h-100"
                  ref={menuRef}
                >
                  <ul className="header-link">
                    <li className="menu-hover">
                      {activeUrl === "/" ? (
                        <NavLink className="nav-bar-link active" to="/">
                          Home
                        </NavLink>
                      ) : (
                        <NavLink className="nav-bar-link" to="/">
                          Home
                        </NavLink>
                      )}
                    </li>
                    {!checkShopListFlow() && 
                    <li className="menu-hover">
                      {activeUrl === "/price" ? (
                        <NavLink className="nav-bar-link active" to="/price">
                          Pricing
                        </NavLink>
                      ) : (
                        <NavLink className="nav-bar-link" to="/price">
                          Pricing
                        </NavLink>
                      )}
                    </li>
                    }
                    <li className="menu-hover">
                      {activeUrl === "/areaCovered" ? (
                        <NavLink
                          className="nav-bar-link active"
                          to="/areaCovered"
                        >
                          Area Covered
                        </NavLink>
                      ) : (
                        <NavLink className="nav-bar-link" to="/areaCovered">
                          Area Covered
                        </NavLink>
                      )}
                    </li>
                    {settings?.WebsiteSettings?.site_title_en ==
                      "Insta Laundry" && (
                      <li className="faq-menu menu-hover">
                        {activeUrl === "/aboutUs" ? (
                          <NavLink
                            className="nav-bar-link active"
                            to="/aboutUs"
                          >
                            About Us
                          </NavLink>
                        ) : (
                          <NavLink className="nav-bar-link" to="/aboutUs">
                            About Us
                          </NavLink>
                        )}
                      </li>
                    )}
                    {checkShopListFlow() && splitURL.length < 3 &&
                      <li className="faq-menu menu-hover">
                        <a target="_blank" href={shopurl} className="signup-m">List Your Laundry</a>
                      </li>
                    }
                    <li className="faq-menu menu-hover">
                      <a target="_blank" href={blogUrl}>Blog</a>
                    </li>
                    <li className="dropdown menu-hover-dropdown services-dropdown">
                      <a
                        href="#"
                        className="dropdown-toggle"
                        role="button"
                      >
                        Services
                      </a>
                      <ul className="pt-0 dropdown-menu services-menu">
                        <li className="dropdown-item p-0">
                          <NavLink 
                            to="/dry-cleaning"
                            state={{
                              title: "OUR DRY CLEANING SERVICES",
                              location: "WOODFORD, UK",
                              companyName: "TOUCH OF CLASS",
                              paragraphs: [
                                "All branches of **TOUCH OF CLASS** provide a dry cleaning service for virtually all items of clothing, whether everyday wear or special garments such as wedding dresses or formal wear.",
                                "Garments are dry cleaned at the can be collected same day provided you bring them in before 11 am."
                              ],
                              images: [
                                dry1,
                                dry2,
                                dry3
                              ],
                              highlightWord: "SERVICES"
                            }}
                          >
                            Dry Cleaning
                          </NavLink>
                        </li>
                        <li className="dropdown-item p-0">
                          <NavLink 
                            to="/curtain-cleaning"
                            state={{
                              title: "CURTAIN CLEANING SERVICE",
                              location: "WOODFORD, UK",
                              companyName: "TOUCH OF CLASS",
                              paragraphs: [
                                "Curtain cleaning is our speciality. We recommend you must clean your curtains twice a year as it will keep the dust mites (causes asthma and respiratory diseases) away. Please keep the size of your curtains in inches to hand while call us.",
                                "We may if required, collect your curtains and deliver them back at a time that suits you. We can also take your curtains down and re-hang them for nominal extra charges. We need the drop and width of each piece of curtain to calculate the cleaning cost."
                              ],
                              images: [
                                curtain1,
                                curtain2,
                                curtain3
                              ],
                              highlightWord: "SERVICE"
                            }}
                            >
                            Curtain Cleaning
                          </NavLink>
                        </li>
                        <li className="dropdown-item p-0">
                          <NavLink 
                            to="/wedding-gown"
                            state={{
                              title: "WEDDING DRESS DRY CLEANING SERVICE",
                              location: "WOODFORD, UK",
                              companyName: "TOUCH OF CLASS",
                              paragraphs: [
                                "The wedding gowns are not an ordinary piece of clothing. The purpose of keeping a wedding gown for years may be different to some than others.",
                                "Some would like to keep it because of the sentimental value attached to it while others may think they will need it again.",
                                "Whatever your purpose to clean or preserve your wedding dress is, we offer the best service for cleaning and preserving your wedding gown."
                              ],
                              images: [
                                wedding1,
                                wedding2,
                                wedding3
                              ],
                              highlightWord: "CLEANING"
                            }}
                            >
                            Wedding Gown
                          </NavLink>
                        </li>
                        <li className="dropdown-item p-0">
                          <NavLink 
                            to="/leather-and-suede-cleaning"
                            state={{
                              title: "LEATHER AND SUEDE CLEANING SERVICE",
                              location: "WOODFORD, UK",
                              companyName: "TOUCH OF CLASS",
                              paragraphs: [
                                "We provides a suede, sheepskin, and leather cleaning service for a range of garments and items, including; coats, jackets, suits, waistcoats, skirts, trousers, gloves, sheepskin rugs, motorcycle leather and handbags.",
                                "Our experienced suede and leather cleaning team are highly trained to produce exceptional results in restoring suede, sheepskin and leather to as near the original condition as possible. We also provide a re-waxing service for leathers.",
                                "Due to the complexity of the processes involved in suede and leather cleaning, service times vary depending on the degree of soiling and staining and whether any alterations or repairs are requested. Contact our nearest branch for details."
                              ],
                              images: [
                                leather1,
                                leather2,
                                leather3
                              ],
                              highlightWord: "SERVICE"
                            }}
                            >
                            Leather and Suede Cleaning
                          </NavLink>
                        </li>
                        <li className="dropdown-item p-0">
                          <NavLink 
                            to="/alteration-and-repairs"
                            state={{
                              title: "ALTERATION AND REPAIR SERVICE",
                              location: "WOODFORD, UK",
                              companyName: "TOUCH OF CLASS",
                              paragraphs: [
                                "We have expert tailors across our shops. They can carry out clothing alterations, repairs and tailoring services that you require. They are fully skilled, experienced and proud of their ability - and it shows!",
                                "Whether it's a simple shortening of a hem or a pair of trousers, invisibly mending a tear, or a major adjustment to an haute couture item, the same dedication goes into the work.",
                                "This attention to detail is paramount in any alteration, be it shortening or lengthening jackets, sleeves, trousers, skirts, dresses, adding or removing turn ups, adjusting waist size, or even just moving buttons."
                              ],
                              images: [
                                alteration1,
                                alteration2,
                                alteration3
                              ],
                              highlightWord: "SERVICE"
                            }}
                            >
                            Alteration and Repairs
                          </NavLink>
                        </li>
                        <li className="dropdown-item p-0">
                          <NavLink 
                            to="/upholstery-and-linen-cleaning"
                            state={{
                              title: "UPHOLSTERY AND LINEN CLEANING SERVICES",
                              location: "WOODFORD, UK",
                              companyName: "TOUCH OF CLASS",
                              paragraphs: [
                                "Upholstery fabric has to face a large amount of wear and tear in the average home; particularly if you have a large family. It is therefore important to keep it clean and well maintained if you want it to last and continue looking good.",
                                "Dry cleaning is the recommended method for cleaning upholstery and carpets. We Use a cleaning product specifically for upholstery."
                              ],
                              images: [
                                upholstery1,
                                upholstery2,
                                upholstery3
                              ],
                              highlightWord: "SERVICES"
                            }}
                            >
                            Upholstery and Linen Cleaning
                          </NavLink>
                        </li>
                        <li className="dropdown-item p-0">
                          <NavLink 
                            to="/duvets-quilts-and-blanket-clean"
                            state={{
                              title: "PROFESSIONAL DUVET, QUILT AND BLANKET CLEANING SERVICES",
                              location: "",
                              companyName: "",
                              paragraphs: [],
                              images: [
                                duvets1,
                                duvets2,
                                duvets3
                              ],
                              highlightWord: "CLEANING"
                            }}
                            >
                            Duvets, Quilts, and Blanket Clean
                          </NavLink>
                        </li>
                        <li className="dropdown-item p-0">
                          <NavLink 
                            to="/fire-proofing"
                            state={{
                              title: "FIREPROOFING AND DRY CLEANING SERVICES",
                              location: "",
                              companyName: "",
                              paragraphs: [],
                              images: [
                                fire1,
                                fire2,
                                fire3
                              ],
                              highlightWord: "CLEANING"
                            }}
                            >
                            Fire Proofing
                          </NavLink>
                        </li>
                        <li className="dropdown-item p-0">
                          <NavLink 
                            to="/key-cutting"
                            state={{
                              title: "Expert Key Cutting Service",
                              location: "",
                              companyName: "",
                              paragraphs: [],
                              images: [
                                key1,
                                key2,
                                key3
                              ],
                              highlightWord: "KEY CUTTING"
                            }}
                            >
                            Key Cutting
                          </NavLink>
                        </li>
                        <li className="dropdown-item p-0">
                          <NavLink 
                            to="/service-washes"
                            state={{
                              title: "PROFESSIONAL WASHING SERVICES",
                              location: "WOODFORD, UK",
                              companyName: "",
                              paragraphs: [],
                              images: [
                                tocservice1,
                                tocservice2,
                                tocservice3
                              ],
                              highlightWord: "WASHING"
                            }}
                            >
                            Service Washes
                          </NavLink>
                        </li>
                        <li className="dropdown-item p-0">
                          <NavLink 
                            to="/shoe-repairs"
                            state={{
                              title: "EXPERT SHOE REPAIR SERVICES",
                              location: "WOODFORD, UK",
                              companyName: "",
                              paragraphs: [],
                              images: [
                                tocsrepair1,
                                tocsrepair2,
                                tocsrepair3
                              ],
                              highlightWord: "SHOE REPAIR"
                            }}
                            >
                            Shoe Repair (Next Day Service)
                          </NavLink>
                        </li>
                        <li className="dropdown-item p-0">
                          <NavLink 
                            to="/rug-cleaning"
                            state={{
                              title: "RESTORE YOUR RUGS TO THEIR FORMER GLORY",
                              location: "",
                              companyName: "TOUCH OF CLASS",
                              paragraphs: [
                                "Touch of class offer FREE collection & delivery for RUG. Bcause some rug are havy and very dusty, so it's hard to carry. this is the reason we come give price. If you like price we collect and drop back to you."
                              ],
                              images: [
                                tocrug1,
                                tocrug2,
                                tocrug3
                              ],
                              highlightWord: "GLORY",
                              coupon: {
                                discount: "10% OFF",
                                title: "SPECIAL OFFER",
                                description: "On All Rugs"
                              }
                            }}
                            >
                            Rug Cleaning Free Collection and Delivery
                          </NavLink>
                        </li>
                        <li className="dropdown-item p-0">
                          <NavLink 
                            to="/ironing-service"
                            state={{
                              title: "EXPERT IRONING SERVICES",
                              location: "",
                              companyName: "",
                              paragraphs: [
                                "We employ only the best ironers and our ironing standard is checked by independent expert regularly. We have diverse client base and our customers come from all the walks of life."
                              ],
                              images: [
                                tocironing1,
                                tocironing2,
                                tocironing3
                              ],
                              highlightWord: "IRONING"
                            }}
                            >
                            Ironing Service
                          </NavLink>
                        </li>
                        <li className="dropdown-item p-0">
                          <NavLink 
                            to="/carpet-cleaner-hire"
                            state={{
                              title: "CARPET CLEANER HIRE SERVICE",
                              location: "WOODFORD, UK",
                              companyName: "",
                              paragraphs: [
                                "This industry standard machine restores carpets and upholstery to showroom conditions. Lightweight and versatile for easy use. Removes dirt, bacteria, allergens and odours.",
                                "For best results use Superclens pre-spray products before carpet cleaning."
                              ],
                              images: [
                                toccarpet1,
                                toccarpet2,
                                toccarpet3
                              ],
                              highlightWord: "CARPET CLEANER"
                            }}
                            >
                            Carpet Cleaner Hire
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                    {userToken && (
                      <li className="dropdown menu-hover-dropdown login-link cart-list dropdown-notification">
                        <Link
                          to="#"
                          id="drop1"
                          data-bs-toggle="dropdown"
                          className="dropdown-toggle"
                        >
                          <i
                            className="fa fa-bell pt-2 float-left"
                            aria-hidden="true"
                            onClick={() => setChangePopup(!changePopup)}
                          ></i>
                          {/* <span
                            id="notify_total_count"
                            className="count-blk pb-1"
                          >
                            {notifyCount.length}
                          </span> */}
                        </Link>
                        <div className="dropdown-menu">
                          <Notification />
                        </div>
                      </li>
                    )}

                    {userToken && (
                      <li className="dropdown menu-hover-dropdown">
                        <Link
                          to="#"
                          id="drop1"
                          data-bs-toggle="dropdown"
                          className="dropdown-toggle"
                          role="button"
                          onClick={() =>
                            setChangePopupProfile(!changePopupProfile)
                          }
                        >
                          {`Hi ${name || userName}!`}
                          <b className="caret"></b>
                        </Link>
                        <div className="dropdown-menu">{<Profile />}</div>
                      </li>
                    )}
                  </ul>
                  {activeUrl != "/checkout" && (
                    <ul className="header-link-right">
                      {/* <li className="d-none d-xl-inline-block"><a href={`tel:${settingsData?.WebsiteSettings?.contact_t5}`}><img src={phonecall} alt="" /><span>{settingsData?.WebsiteSettings?.contact_t5}</span></a></li> */}
                      <li>
                        <div
                          className="header-cart-box"
                          onClick={cartboxOpen}
                        >
                          <i
                            className="uil uil-shopping-cart"                           
                          ></i>
                          <div className="cart-box-info">
                            <span
                              id="cart_total_count">
                              {
                                homedata?.theme_10?.home?.header?.nav
                                  ?.cart_section?.cart_label_section?.label
                              }{" "}
                              {cartCounts}
                            </span>
                            <span
                              
                              className="count-blk title"
                            >
                              {settingsData?.WebmasterSettings?.currency}
                              {finalTotalPrice.toFixed(2)}
                            </span>
                          </div>
                        </div>
                      </li>
                      {!userToken &&
                        homedata?.theme_10?.home?.header?.btn_group?.btn1
                          ?.btn1_is_enable === true && (
                          <>
                            <li className="header-auth header-box menu-hover">
                              <Link
                                to="/login"
                                
                              >
                                <i className="uil uil-users-alt"></i>
                                {
                                  homedata?.theme_10?.home?.header?.btn_group
                                    ?.btn1?.text
                                }
                              </Link>
                            </li>
                          </>
                        )}
                      {settingsData?.quick_order_mode != 0 &&
                      homedata?.theme_10?.home?.header?.btn_group?.btn2
                        ?.btn2_is_enable === true ? (
                        <>
                          <li
                            className="login menu-hover">
                            <Link
                              to="#"
                              data-bs-toggle="modal"
                              data-bs-target="#quickordermodal"
                              className="title-btn btn"
                              style={{
                                border: `2px solid #${homedata?.theme_10?.home?.header?.btn_group?.btn2?.border_color}`,
                                background: `#${homedata?.theme_10?.home?.header?.btn_group?.btn2?.bg_color}`,
                                color: `#${homedata?.theme_10?.home?.header?.btn_group?.btn2?.color}`,
                              }}
                            >
                              <i className="uil uil-shuffle"></i>
                              {
                                homedata?.theme_10?.home?.header?.btn_group?.btn2
                                  ?.text
                              }
                            </Link>
                          </li>
                        </>
                      ) : null}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <nav
        id="sidebar"
        className="mCustomScrollbar _mCS_1 mCS-autoHide mCS_no_scrollbar"
        style={{ overflow: "visible" }}
      >
        <div
          id="mCSB_1"
          className="mCustomScrollBox mCS-minimal mCSB_vertical mCSB_outside"
          style={{ maxHeight: "480px" }}
        >
          <div
            id="mCSB_1_container"
            className="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
            style={{ position: "relative", top: "0px", left: "0px" }}
            dir="ltr"
          >
            <div id="dismiss" onClick={sidebarClose}>
              <i className="fa fa-arrow-left"></i>
            </div>
            <div className="sidebar-header"></div>
            <ul className="list-unstyled components">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/price">Pricing</Link>
              </li>
              <li>
                <Link to="/areaCovered">Area Covered</Link>
              </li>
              {checkShopListFlow() && splitURL.length < 3 &&
                <li className="btnmoblist">
                  <a target="_blank" href={shopurl} className="btn">List Your Laundry</a>
                </li>
              }
            </ul>
          </div>
        </div>
        <div
          id="mCSB_1_scrollbar_vertical"
          className="mCSB_scrollTools mCSB_1_scrollbar mCS-minimal mCSB_scrollTools_vertical"
          style={{ display: "none" }}
        >
          <div className="mCSB_draggerContainer">
            <div
              id="mCSB_1_dragger_vertical"
              className="mCSB_dragger"
              style={{
                position: "absolute",
                minHeight: "0px",
                height: "0px",
                top: "0px",
                display: "block",
              }}
            >
              <div
                className="mCSB_dragger_bar"
                style={{ lineHeight: "0px" }}
              ></div>
            </div>
            <div className="mCSB_draggerRail"></div>
          </div>
        </div>
      </nav>
      <div id="overlay" onClick={sidebarClose}></div>
      <div
        className="modal fade"
        id="quickordermodal"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
              <QuickOrderPopup close={closeQuickOrderPopup} />
          </div>
        </div>
      </div>
      <div id="cd-shadow-layer" onClick={cartboxClose}></div>
      {<CartSummary />}
    </div>
  );
}

export default HeaderBlack;
